/**
 * Free text that looks like an item key typed so far. Pure: shared by toSql and toPredicate.
 *
 * `PLZ-1` matches PLZ-1, PLZ-10, PLZ-123...; `plz-` matches every key of product PLZ. A bare word (`plz`) is
 * NOT treated as a key prefix: it would match every item of a product on the first keystrokes. A key-shaped
 * word needs the dash (product key of 2 to 10 letters/digits starting with a letter, then `-`, then optional digits).
 */
const KEY_PREFIX = /^([A-Za-z][A-Za-z0-9]{1,9})-(\d{0,9})$/;

/** Upper-cased key prefix ("PLZ-1") when `text` looks like a (partial) item key, else null. */
export function itemKeyPrefix(text: string): string | null {
  const m = KEY_PREFIX.exec(text.trim());
  return m ? `${m[1]!.toUpperCase()}-${m[2]}` : null;
}
